module.exports = __webpack_public_path__ + "img/title4.e0c54664.png";